module.exports = __webpack_public_path__ + "static/user5-57e29bd09f31f52fdc2fa48585469c3f.jpg";